<template>
    <div>
        <div v-if="admin" class="">
            <v-autocomplete v-model="select" v-model:search="search" :loading="loading" :items="items" cache-items
                hide-no-data :label="$tr('Добавьте пользователей')" :custom-filter="filter" item-title="uid"
                item-value="uid">
                <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" style="max-width: 380px;" :prepend-avatar="userAvatar(item?.raw)"
                        :title="userName(item?.raw)" :subtitle="item?.raw?.uid || item?.raw?.desc"></v-list-item>
                </template>
            </v-autocomplete>
        </div>
        <div v-for="user in users" :key="user.id" class="permission-row">
            <user-view :user="user" />
            <div>
                <v-btn variant="text" :disabled="!admin || user.id == drive.user">
                    {{ user.id == drive.user ? $tr('Владелец') : userPermission(user.id) }}
                </v-btn>
                <dropdown-menu v-if="admin && user.id != drive.user" :actions="userMenu(user)" />
            </div>
        </div>
        <div v-for="group in groups" :key="group.id" class="permission-row">
            <user-view :group="group" />
            <div>
                <v-btn variant="text" :disabled="!admin">
                    {{ groupPermissionName(group.id) }}
                </v-btn>
                <dropdown-menu v-if="admin" :actions="groupMenu(group)" />
            </div>
        </div>
    </div>
</template>

<script>
import DropdownMenu from '@topomatic/tap/src/components/DropdownMenu.vue';
import UserView from '@topomatic/tap/src/components/UserView.vue';
import { AvatarUri } from '@topomatic/tap/src/md5';
import Utils from '@topomatic/tap/src/utils';
import AppConsts from '../consts';

class GroupAction {
    constructor(owner, group, permission) {
        this.owner = owner;
        this.group = group;
        this.permission = permission;
        this.title = AppConsts.permission_name(permission);
    }

    onclick() {
        const { path } = this.owner.data;
        const group = this.group.id;
        const drive = path[0];
        let { groups } = drive;
        if (groups == undefined) {
            groups = {};
        }
        if (groups[group] == undefined) {
            this.owner.$api.changeGroupPermissions(drive.id, group, AppConsts.PERMISSION_METADATA)
                .then(() => {
                    if (drive.groups == undefined) {
                        const ngroups = {};
                        ngroups[group] = AppConsts.PERMISSION_METADATA;
                        drive.groups = ngroups;
                    } else {
                        drive.groups[group] = AppConsts.PERMISSION_METADATA;
                    }
                    if (this.permission > AppConsts.PERMISSION_METADATA) {
                        this.updateFile();
                    }
                });
        } else {
            this.updateFile();
        }
    }

    updateFile() {
        const { file } = this.owner.data;
        const group = this.group.id;
        let { groups } = file;
        if (groups == undefined) {
            groups = {};
        }
        if (groups[group] != this.permission) {
            this.owner.$api.changeGroupPermissions(file.id, group, this.permission)
                .then(() => {
                    if (file.groups == undefined) {
                        const ngroups = {};
                        ngroups[group] = this.permission;
                        file.groups = ngroups;
                    } else {
                        file.groups[group] = this.permission;
                    }
                });
        }
    }
}

class UserAction {
    constructor(owner, user, permission) {
        this.owner = owner;
        this.user = user;
        this.permission = permission;
        this.title = AppConsts.permission_name(permission);
    }

    onclick(callback) {
        const { path } = this.owner.data;
        const { file } = this.owner.data;
        const user = this.user.id;
        const drive = path[0];
        let { users } = drive;
        if (users == undefined) {
            users = {};
        }
        if (users[user] == undefined) {
            this.owner.$api.changeUserPermissions(drive.id, user, AppConsts.PERMISSION_METADATA)
                .then(() => {
                    if (drive.users == undefined) {
                        const nusers = {};
                        nusers[user] = AppConsts.PERMISSION_METADATA;
                        drive.users = nusers;
                    } else {
                        drive.users[user] = AppConsts.PERMISSION_METADATA;
                    }
                    if ((drive.id != file.id) && (this.permission > AppConsts.PERMISSION_METADATA)) {
                        this.updateFile(callback);
                    } else if (typeof callback === 'function') {
                        callback();
                    }
                }).catch(() => {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
        } else {
            this.updateFile(callback);
        }
    }

    updateFile(callback) {
        const { file } = this.owner.data;
        const user = this.user.id;
        let { users } = file;
        if (users == undefined) {
            users = {};
        }
        if (users[user] != this.permission) {
            this.owner.$api.changeUserPermissions(file.id, user, this.permission)
                .then(() => {
                    if (file.users == undefined) {
                        const nusers = {};
                        nusers[user] = this.permission;
                        file.users = nusers;
                    } else {
                        file.users[user] = this.permission;
                    }
                    if (typeof callback === 'function') {
                        callback();
                    }
                }).catch(() => {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
        } else if (typeof callback === 'function') {
            callback();
        }
    }
}

class RemoveAction {
    constructor(owner, user) {
        this.owner = owner;
        this.user = user;
        this.title = owner.$tr('Удалить');
    }

    onclick() {
        const { path } = this.owner.data;
        const user = this.user.id;
        const drive = path[0];
        this.owner.$api.deleteUserPermissions(drive.id, user, AppConsts.PERMISSION_METADATA)
            .then(() => {
                if (drive.users != undefined) {
                    delete drive.users[user];
                }
            });
    }
}

class RemoveGroupAction {
    constructor(owner, group) {
        this.owner = owner;
        this.group = group;
        this.title = owner.$tr('Удалить');
    }

    onclick() {
        const { path } = this.owner.data;
        const group = this.group.id;
        const drive = path[0];
        this.owner.$api.deleteGroupPermissions(drive.id, group, AppConsts.PERMISSION_METADATA)
            .then(() => {
                if (drive.groups != undefined) {
                    delete drive.groups[group];
                }
            });
    }
}

const ALL_PERMISSIONS = [
    AppConsts.PERMISSION_NONE,
    AppConsts.PERMISSION_METADATA,
    AppConsts.PERMISSION_COMMENT | AppConsts.PERMISSION_METADATA,
    AppConsts.PERMISSION_READ | AppConsts.PERMISSION_COMMENT | AppConsts.PERMISSION_METADATA,
    AppConsts.PERMISSION_DELETE | AppConsts.PERMISSION_CREATE | AppConsts.PERMISSION_UPDATE
    | AppConsts.PERMISSION_READ | AppConsts.PERMISSION_COMMENT | AppConsts.PERMISSION_METADATA,
    AppConsts.PERMISSION_ADMIN | AppConsts.PERMISSION_DELETE | AppConsts.PERMISSION_CREATE
    | AppConsts.PERMISSION_UPDATE | AppConsts.PERMISSION_READ | AppConsts.PERMISSION_COMMENT
    | AppConsts.PERMISSION_METADATA,
];

export default {
    components: {
        UserView,
        DropdownMenu,
    },
    name: 'PermissionsView',
    data() {
        return {
            loading: false,
            search: null,
            select: null,
        };
    },
    watch: {
        search(val) {
            if (val && val !== this.select) {
                this.querySelections(val);
            }
        },
        select(val) {
            if (val != undefined) {
                this.loading = true;
                if (typeof val === 'string') {
                    this.$api.find_user(val)
                        .then((user) => {
                            new UserAction(this, user, AppConsts.PERMISSION_METADATA).onclick(() => {
                                this.loading = false;
                                this.select = undefined;
                                this.search = undefined;
                            });
                        }).catch(() => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                    this.select = undefined;
                    this.search = undefined;
                    new GroupAction(this, val, AppConsts.PERMISSION_METADATA).onclick();
                }
            }
        },
    },
    props: {
        data: Object,
    },
    computed: {
        drive() {
            const { path } = this.data;
            if ((path != undefined) && (path.length > 0)) {
                return path[0];
            }
            return undefined;
        },
        admin() {
            const permissions = this.data.permissions.value || this.data.permissions;
            return (permissions & AppConsts.PERMISSION_ADMIN) == AppConsts.PERMISSION_ADMIN;
        },
        owner() {
            const { drive } = this;
            return drive != undefined ? drive.company : undefined;
        },
        groups() {
            const { owner } = this;
            if (owner != undefined) {
                const groups = this.$api.get_groups(owner);
                const filtered = {};
                for (const id in groups) {
                    const group = groups[id];
                    if (this.groupPermission(group.id) !== undefined) {
                        filtered[id] = group;
                    }
                }
                return filtered;
            }
            return {};
        },
        users() {
            const result = [];
            const { drive } = this;
            if (drive != undefined) {
                if (drive.user != undefined) {
                    const user = this.$api.get_user(drive.user);
                    if (user != undefined) {
                        result.push(user);
                    }
                }
                const { users } = drive;
                if (users != undefined) {
                    const ids = Object.keys(users);
                    for (let i = 0; i < ids.length; i++) {
                        const id = ids[i];
                        const user = this.$api.get_user(id);
                        if (user != undefined) {
                            result.push(user);
                        }
                    }
                }
            }
            return result;
        },
        items() {
            const ekeys = {};
            const eusers = this.users;
            for (let i = 0; i < eusers.length; i++) {
                ekeys[eusers[i].id] = eusers;
            }
            const users = this.$api.get_all_users();
            const result = [];
            for (let i = 0; i < users.length; i++) {
                if (ekeys[users[i].id] == undefined) {
                    result.push(users[i]);
                }
            }
            const { owner } = this;
            if (owner != undefined) {
                const egroups = this.groups;
                const groups = this.$api.get_groups(owner);
                for (const id in groups) {
                    const group = groups[id];
                    if (egroups[group.id] === undefined) {
                        result.push(group);
                    }
                }
            }
            return result;
        },
    },
    methods: {
        owned(user) {
            return user.id == this.drive.user;
        },
        userName(user) {
            return Utils.userToString(user);
        },
        userAvatar(user) {
            const email = user.email || user.uid;
            if (email == undefined) {
                return undefined;
            }
            return AvatarUri(email, 40);
        },
        filter(title, query, item) {
            const user = item.raw;
            const q = query.toLowerCase();
            const uid = user.email || user.uid || user.name || user.desc;
            if (uid?.toLowerCase()?.indexOf(q) >= 0) {
                return true;
            }
            if (this.userName(user).toLowerCase().indexOf(q) >= 0) {
                return true;
            }
            return false;
        },
        groupPermission(group) {
            const { path } = this.data;
            for (let i = path.length - 1; i >= 0; i--) {
                const { groups } = path[i];
                if (groups != undefined) {
                    const permission = groups[group];
                    if (permission != undefined) {
                        return permission;
                    }
                }
            }
            return undefined;
        },
        groupPermissionName(group) {
            return AppConsts.permission_name(this.groupPermission(group) ?? AppConsts.PERMISSION_NONE);
        },
        groupMenu(group) {
            const actions = [];
            for (let i = 0; i < ALL_PERMISSIONS.length; i++) {
                actions.push(new GroupAction(this, group, ALL_PERMISSIONS[i]));
            }
            actions.push({
                title: '-',
            });
            actions.push(new RemoveGroupAction(this, group));
            return actions;
        },
        userPermission(user) {
            const { path } = this.data;
            for (let i = path.length - 1; i >= 0; i--) {
                const { users } = path[i];
                if (users != undefined) {
                    const permission = users[user];
                    if (permission != undefined) {
                        return AppConsts.permission_name(permission);
                    }
                }
            }
            return AppConsts.permission_name(AppConsts.PERMISSION_NONE);
        },
        userMenu(user) {
            const actions = [];
            for (let i = 0; i < ALL_PERMISSIONS.length; i++) {
                actions.push(new UserAction(this, user, ALL_PERMISSIONS[i]));
            }
            actions.push({
                title: '-',
            });
            actions.push(new RemoveAction(this, user));
            return actions;
        },
        querySelections(value) {
            const dog = value.indexOf('@');
            const dot = value.indexOf('.', dog + 1);
            if (dog > 0 && dot > 0 && value.length - dot > 2) {
                this.loading = true;
                this.$api.find_user(value).finally(() => {
                    this.loading = false;
                });
            }
        },
    },
};
</script>

<style scoped>
.permission-row {
    align-items: center;
    justify-content: space-between !important;
    display: flex !important;
}
</style>
